import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/header.css';

function Header() {
  const [menuActive, setMenuActive] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isJobViewPage = /^\/jobs\/[^/]+\/?$/.test(location.pathname);
  const isAdminPage = location.pathname.startsWith('/admin');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };

    if (!isJobViewPage) {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    } else {
      setScrolled(true);
    }
  }, [isJobViewPage]);

  const handleScrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMenuActive(false);
  };

  const homeClick = () => {
    navigate('/');
    setMenuActive(false);
    window.scrollTo(0, 0);
  };

  const careerClick = () => {
    navigate('/jobs');
    setMenuActive(false);
    window.scrollTo(0, 0);
  };

  const aboutClick = () => {
    navigate('/about');
    setMenuActive(false);
    window.scrollTo(0, 0);
  };

  const servicesClick = () => {
    navigate('/services');
    setMenuActive(false);
    window.scrollTo(0, 0);
  };

  const contactClick = () => {
    navigate('/contact');
    setMenuActive(false);
    window.scrollTo(0, 0);
  };

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  // ✅ Conditional rendering AFTER hooks are declared
  if (isAdminPage) {
    return null;
  }

  return (
    <header className={`header ${scrolled || isJobViewPage ? 'scrolled' : ''}`}>
      <div className="logo" onClick={() => handleScrollToSection('home')}>
        <span className="logo-text">VSK Global Infotech</span>
      </div>

      <nav>
        <ul className={`nav-links ${menuActive ? 'active' : ''}`}>
          <li onClick={homeClick}>Home</li>
          <li onClick={aboutClick}>About</li>
          <li onClick={servicesClick}>Services</li>
          <li onClick={careerClick}>Career</li>
          <li onClick={contactClick}>Contact</li>
        </ul>
      </nav>

      <div className={`hamburger ${menuActive ? 'active' : ''}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
}

export default Header;
